module.exports = __webpack_public_path__ + "static/its-a-date-logo-d092c57947368c2c2bfa198be19c01e7.png";